var _path, _rect, _rect2, _rect3, _rect4, _path2, _rect5, _rect6, _rect7, _rect8, _path3, _rect9, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAgreementServiceMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 116,
    viewBox: "0 0 144 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7534 37.6777L101.691 29.5387C104.732 28.9622 107.712 30.7938 108.572 33.7674L116.798 62.221C119.099 70.182 115.325 78.6425 107.864 82.2485L70.6146 100.251L58.7534 37.6777Z",
    fill: "#EEC2B9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.377,
    y: 32.4355,
    width: 80.2358,
    height: 13.4079,
    rx: 6,
    transform: "rotate(33.2866 53.377 32.4355)",
    fill: "#FFDCD5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.0093,
    y: 43.6367,
    width: 77.4373,
    height: 14.5252,
    rx: 6,
    transform: "rotate(33.2866 46.0093 43.6367)",
    fill: "#FFDCD5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0288,
    y: 55.7725,
    width: 71.3343,
    height: 13.4079,
    rx: 6,
    transform: "rotate(33.2866 38.0288 55.7725)",
    fill: "#FFDCD5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.6616,
    y: 66.9736,
    width: 67.8747,
    height: 13.4079,
    rx: 6,
    transform: "rotate(33.2866 30.6616 66.9736)",
    fill: "#FFDCD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.695 31.7511C45.5583 28.9213 49.3935 28.1946 52.1629 30.1465L78.218 48.5109C80.866 50.3774 81.5542 54.009 79.7725 56.7148L55.7697 93.1685C53.9064 95.9983 50.0712 96.725 47.3018 94.7731L21.2467 76.4087C18.5987 74.5422 17.9105 70.9106 19.6922 68.2048L43.695 31.7511Z",
    fill: "#FFDCD5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7788,
    y: 82.1553,
    width: 12.2906,
    height: 22.1237,
    rx: 4,
    transform: "rotate(33.0034 43.7788 82.1553)",
    fill: "#EEC2B9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5474,
    y: 75.3467,
    width: 12.2906,
    height: 17.8772,
    rx: 4,
    transform: "rotate(33.0034 33.5474 75.3467)",
    fill: "#EEC2B9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 64.2417,
    y: 95.7744,
    width: 12.2906,
    height: 16.1349,
    rx: 4,
    transform: "rotate(33.0034 64.2417 95.7744)",
    fill: "#EEC2B9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0098,
    y: 88.9648,
    width: 12.2906,
    height: 19.1262,
    rx: 4,
    transform: "rotate(33.0034 54.0098 88.9648)",
    fill: "#EEC2B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3913 38.3133L85.6484 32.5778L79.2944 46.5L61.0419 49.7516L54.2678 62.0344C52.3317 65.5449 48.0961 67.0803 44.3602 65.6258L43.8772 65.4378C42.3261 64.8339 41.5632 63.0827 42.1772 61.5355L49.4454 43.2222C50.456 40.6757 52.6995 38.8235 55.3913 38.3133Z",
    fill: "#EEC2B9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 99.481,
    y: 19.9805,
    width: 24.5811,
    height: 64.597,
    rx: 4,
    transform: "rotate(-18.9457 99.481 19.9805)",
    fill: "#374969"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 24.5811,
    height: 64.597,
    rx: 4,
    transform: "matrix(-0.818407 -0.574639 -0.574639 0.818407 57.5317 26.8486)",
    fill: "#F5F5F5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAgreementServiceMain);
export default __webpack_public_path__ + "static/media/IcAgreementServiceMain.48875b99b2d2fa87921b8061bf35c0e3.svg";
export { ForwardRef as ReactComponent };